<template>
    <div class="table-header">
        <slot />
    </div>
</template>

<script>
    export default {
        name: 'app-table-header'
    }
</script>

<style lang="scss">
    .table-header {
        display: table-header-group;
    }
</style>


// WEBPACK FOOTER //
// src/components/table/Header.vue